import PropTypes from '../_util/vue-types';

export default {
  name: 'ATableColumnGroup',
  props: {
    title: PropTypes.any
  },
  __ANT_TABLE_COLUMN_GROUP: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/table/ColumnGroup.js
// module id = 900
// module chunks = 0